import { createRouter, createWebHistory } from "vue-router";
import { isUserLoggedIn } from "~/service/auth";
import { canNavigate } from "~/composables/useAbility";
import { landingRoutes } from "./routes/landing";
import { cabinetRoutes } from "./routes/cabinet";
import { configure, done, start } from "nprogress";
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [...landingRoutes, ...cabinetRoutes],
});

// const subdomain = window.location.hostname.split(".")[0];
// router.beforeEach((to, from, next) => {
//   if (!canNavigate(to)) {
//     next("/not-authorized");
//   } else if (
//     !isUserLoggedIn() &&
//     !to.path.startsWith("/auth/login/forget-password") &&
//     to.path !== "/auth/login"
//   ) {
//     next(`/auth/login?redirectedFrom=${from.path}`);
//   } else if (isUserLoggedIn() && to.path === "/auth/login") {
//     next("/");
//   } else {
//     next();
//   }
// });

router.onError((error, to, from) => {
  console.error("Router error:", error);
});

router.beforeEach(async (to, from, next) => {
    if (window.innerWidth > 768) {
        start();
    }

    next();
});
router.afterEach(() => {
    if (window.innerWidth > 768) {
        done();
    }
});


export default router;
